import React from 'react';
import { Route, IndexRoute } from 'react-router';
import _ from 'lodash';
import {
  moversFolder,
  checkoutFolder,
  accountFolder
} from './util/constants/directory';
import {setFlow} from './redux/modules/common/common';
import App from './components/App';
import NotFoundPage from './components/NotFoundPage';

// Omni flow pages
import OmniSalesPage from './containers/Omni/OmniSales/OmniSalesPage.jsx';

export const getFlow = dispatch => {
  const flows = [
    { "movers": moversFolder },
    { "quickCheckout": checkoutFolder },
    { "account": accountFolder },
    { "myPlan": '' }
  ];

  const subRouteContainsFolder = (route = "", folder) => route.indexOf(folder) > -1;

  return (nextState) => {
    const subRoute = _.get(nextState, 'routes[1].path');

    flows.some(flow => {
      let flowName = _.head(Object.keys(flow)),
          flowFolder = flow[flowName];

      return subRouteContainsFolder(subRoute, flowFolder) ? dispatch(setFlow(flowName)) : false;
    });
  };
};

const routes = (store) => (
  <Route path="/" component={App} onEnter={getFlow(store)}>
    <IndexRoute component={OmniSalesPage} />
    <Route path="/omnisales" component={OmniSalesPage} />
    <Route path="*" component={NotFoundPage} />
  </Route>
);

export default routes;



/** WEBPACK FOOTER **
 ** ./client/routes.js
 **/